<header class="ma__header" id="header" role="banner">
    <a class="ma__header__skip-nav" href="{{url}}#main-content">skip to main content</a>
    <app-blue-ribbon></app-blue-ribbon>
    <div class="ma__header__container">
        <div class="ma__header__logo">
            <h1 class="ma__site-logo" style="margin-bottom:.5rem">
                <a [routerLink]="['/home']" title="MEPA E-Monitor">Home
                    <img alt="MEPA e-monitor Logo" src={{logoUrl}}>
                </a>
            </h1>
        </div>
    </div>
    <nav aria-label="main_navigation" class="ma__header__nav" id="main-navigation" role="navigation">
        <h2 class="visually-hidden" id="main_navigation">
            Main Navigation
        </h2>
        <div class="ma__header__button-container js-sticky-header">
            <button class="ma__header__back-button js-close-sub-nav">
                <span>Back</span>
            </button>
            <button class="ma__header__menu-button js-header-menu-button" (click)="ShowMobileMenu()">
                <span>Menu</span><span class="ma__header__menu-icon"></span>
            </button>
        </div>
        <div class="ma__header__nav-container">
            <div class="ma__header__main-nav">
                <section class="ma__main-nav">
                    <ul class="ma__main-nav__items js-main-nav" (click)="ShowMobileMenu()">
                        <li class="ma__main-nav__item">
                            <a class="ma__main-nav__top-link active" routerLink="/home" tabindex="0" routerLinkActive="active" #menuItemHome="routerLinkActive" [attr.aria-current]="menuItemHome.isActive ? 'page' : undefined">Home</a>
                        </li>
                        <li class="nav-item dropdown ma__main-nav__item  has-subnav js-main-nav-toggle">
                            <a class="ma__main-nav__top-link" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" tabindex="0">Search</a>
                            <div class="dropdown-menu ma__main-nav__subitems js-main-nav-content" aria-labelledby="navbarDropdown">
                                <ul id="menu1" role="menu" aria-labelledby="navbarDropdown" class="ma__main-nav__container">
                                    <li role="menuitem" aria-label="Empty Menu Item"></li>
                                    <li role="menuitem" class="ma__main-nav__subitem">
                                        <a class="ma__main-nav__link" routerLink="/search" routerLinkActive="active" #menuItemSearch="routerLinkActive" [attr.aria-current]="menuItemSearch.isActive ? 'page' : undefined">Projects</a>
                                    </li>
                                    <li role="menuitem" class="ma__main-nav__subitem">
                                        <a class="ma__main-nav__link" routerLink="/searchPublication" routerLinkActive="active" #menuItemSearchPublication="routerLinkActive" [attr.aria-current]="menuItemSearchPublication.isActive ? 'page' : undefined">Publications</a>
                                    </li>
                                    <li role="menuitem" class="ma__main-nav__subitem">
                                        <a class="ma__main-nav__link" routerLink="/recentDecisions" routerLinkActive="active" #menuItemRecentDecisions="routerLinkActive" [attr.aria-current]="menuItemRecentDecisions.isActive ? 'page' : undefined">Recent
                                            Decisions</a>
                                    </li>
                                    <li role="menuitem" aria-label="Empty Menu Item"></li>
                                </ul>
                            </div>
                        </li>
                        <li class="ma__main-nav__item">
                            <a class="ma__main-nav__top-link" target="_blank" href="https://www.mass.gov/service-details/mepa-resources" tabindex="0" title="Go to external link name(opens in new window)">
                                Resources</a>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </nav>
</header>
<main id="main-content" role="main" tabindex="-1">
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>